export const VIEW_MODE_BROWSE = 'browse'
export const VIEW_MODE_SEARCH = 'search'
export const ITEMS_PER_PAGE = 50
export const INFINITE_SCROLL_THRESHOLD = 600 // The distance in pixels before the end of the items that will trigger a call to loadMore. Deprecated.
export const MAX_ASSETS_FILTERS_TAGS = 15 // How many tags/keywords to show in the filters bar

// Map of asset types to detail URLs paths
export const ASSET_URL_TYPES = {
  fc_effects: '/video-effects',
  gc_images: '/stock-image-hd',
  rc_environments: '/environments',
  rc_materials: '/materials',
  rc_objects: '/objects',
  sc_sounds: ['/sounds-effects', '/royalty-free-music'],
}
